import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";


const useStyles = makeStyles((theme) => ({
    toggleGroup: {
        margin: theme.spacing(5),
        height: "30px",
        "& .MuiToggleButton-root.Mui-selected": {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            backgroundColor: "transparent"
        }
    },
    toggleButton: {
        height: "30px",
        padding: "2px",
        width: "130px"
    }
}));

export default function CustomToggleButton({ labels, value, onChange }) {
    const classes = useStyles();
    const [filterStarred, setFilterStarred] = useState(value);

    useEffect(() => {
        setFilterStarred(value);
     }, [value]);

    const handleChange = (event, isStarred) => {
        setFilterStarred(isStarred);
        onChange(isStarred);
    };

    return (
        <ToggleButtonGroup
            className={classes.toggleGroup}
            value={filterStarred}
            exclusive
            onChange={handleChange}
        >
            <ToggleButton className={classes.toggleButton} value={false} aria-label="all-items">
                {labels.left}
            </ToggleButton>
            <ToggleButton className={classes.toggleButton} value={true} aria-label="starred-items">
                {labels.right}
            </ToggleButton>
        </ToggleButtonGroup>
    );
}

CustomToggleButton.propTypes = {
    labels: PropTypes.shape({
		left: PropTypes.string,
		right: PropTypes.string,
	}),
    value: PropTypes.bool,
    onChange: PropTypes.func
};
